import { mapGetters } from 'vuex'

import { get } from 'lodash'

import { Services, getPrice, getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'
import { RECURRENT_PAYMENTS_STATUSES, RECURRENT_PAYMENTS_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { generateServices, globalErrorHandler, permissionPresets, request } from '@/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(Services.recurrentPayments)

export default {
  name: 'Item',

  mixins: [
    generateServices({
      name: Services.recurrentPayments,

      find: false,
      create: false,

      update: {
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      }
    })
  ],

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isPage: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      currency: undefined,
      showDialog: false,
      showEventsHistoryDialog: false
    }
  },

  computed: {
    ...mapGetters({ token: 'authentication/token' }),

    canGetUsersAsAdmin() {
      return this.checkPermissions(`advanced.${Services.users}.get`)
    },
    canGetUsersAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    },
    canUpdateRecurrentPayments() {
      return this.checkPermissions(`advanced.${Services.recurrentPayments}.update`, permissionPresets.meUp)
    },

    period() {
      switch (this.value.type) {
        case RECURRENT_PAYMENTS_TYPES.threshold: {
          return this.getTranslate(`${Services.recurrentPayments}.contents.${this.value.type}`, { threshold: getPrice(this.value.threshold, { currency: this.currency }) })
        }
        case RECURRENT_PAYMENTS_TYPES.frequency: {
          return this.getTranslate(`${Services.tasks}.frequencies.${this.value.frequency}`)
        }
      }
    },

    isPaused() {
      return this.value.status === RECURRENT_PAYMENTS_STATUSES.pause
    },

    amountLabel() {
      if (!this.viewport.breakpoint.mdUp) {
        if (this.canGetUsersAsAdmin) {
          return get(this.value, 'Owner.username')
        }
      }

      return this.getTranslate(`${Services.recurrentPayments}.labels.amount`)
    },

    ownerId() {
      return get(this.value, 'Owner.id', this.value.OwnerId)
    }
  },

  watch: {
    ownerId: 'getCurrency'
  },

  mounted() {
    this.getCurrency()
  },

  methods: {
    async repeatRecurrentPayment() {
      if (this.canUpdateRecurrentPayments) {
        if (~[ RECURRENT_PAYMENTS_STATUSES.init, RECURRENT_PAYMENTS_STATUSES.error ].indexOf(this.value.status)) {
          try {
            const data = await request.get(joinURLPath(pathToAPI, this.value.id, 'reInit'), undefined, { method: this.value.method })
            if (data) {
              const { url } = data
              if (url) {
                window.location.href = url
              }
            }
          } catch (error) {
            globalErrorHandler(error)
          }
        }
      }
    },

    async activateRecurrentPayment() {
      if (this.canUpdateRecurrentPayments) {
        if (!~[ RECURRENT_PAYMENTS_STATUSES.init, RECURRENT_PAYMENTS_STATUSES.error ].indexOf(this.value.status)) {
          try {
            let nextStatus = RECURRENT_PAYMENTS_STATUSES.pause
            if (this.isPaused) {
              nextStatus = RECURRENT_PAYMENTS_STATUSES.ready
            }

            await this.rest[Services.recurrentPayments].update(this.value.id, Object.assign(
              {},
              this.value,
              { status: nextStatus }
            ))
          } catch (error) {
            globalErrorHandler(error)
          }
        }
      }
    },

    async getCurrency() {
      if (this.ownerId) {
        const data = await request.get(joinURLPath(Services.users, this.ownerId), undefined, { $scope: [ 'full' ] })
        if (data) {
          this.currency = get(data.settings, 'billings.currency', this.globalSettings.billings.currency)
        }
      }
    }
  },

  render
}
